import { c as _c } from "react/compiler-runtime";
import { AutoshipExistingSubscriberContent, AutoshipFirstTimeEligibleContent, AutoshipMapRestrictedContent } from './AutoshipDynamicContent';
import { getAutoshipDrawerDiscountMessage, isSkuMapRestricted } from './lib';
type AutoshipInfoDrawerHeaderProps = {
  discountDisplay?: string;
  isFirstAutoshipEligible: boolean;
};
export const AutoshipInfoDrawerHeader = t0 => {
  const $ = _c(10);
  const {
    discountDisplay,
    isFirstAutoshipEligible
  } = t0;
  if (isSkuMapRestricted(discountDisplay)) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <AutoshipMapRestrictedContent />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== discountDisplay || $[2] !== isFirstAutoshipEligible) {
    t1 = getAutoshipDrawerDiscountMessage({
      discountDisplay,
      isFirstAutoshipEligible
    });
    $[1] = discountDisplay;
    $[2] = isFirstAutoshipEligible;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    discount,
    maxSavings
  } = t1;
  if (isFirstAutoshipEligible) {
    let t2;
    if ($[4] !== discount || $[5] !== maxSavings) {
      t2 = <AutoshipFirstTimeEligibleContent discount={discount} maxSavings={maxSavings} />;
      $[4] = discount;
      $[5] = maxSavings;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] !== discount || $[8] !== maxSavings) {
    t2 = <AutoshipExistingSubscriberContent discount={discount} maxSavings={maxSavings} />;
    $[7] = discount;
    $[8] = maxSavings;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};